// Modules
import React from "react";

// Styles
import './CheckAvailability.sass';

// Interfaces
import FilterResult from "Interfaces/FilterResultInterface";
import SelectedFilters from "Interfaces/SelectedFiltersInterface";
import { HoldRequestData } from "Interfaces/HoldRequestData";
import { WaitlistData } from "Interfaces/WaitlistData"
import ContractType from "Interfaces/AdvanceSearchInterface";
import { EnhancedSegment } from "Interfaces/Segment";
import Criteria from "Interfaces/CriteriaInterface";
import FormData from "Interfaces/FormDataInterface";
import Results from "Interfaces/ResultsInterface";

// Components
import CheckAvailabilityResultItem from "./CheckAvailabilityResultItem";
import MvFilterBtn from "Generic/Buttons/MvFilterSortBtn/MvFilterBtn";
import { MvSortMobileTable } from "Generic/MvSortMobileTable";

type CheckAvailabilityState = {
  dateSelected: boolean,
  hideHeader: boolean,
  isMobileFilterOpen: boolean,
}

type Props = {
  result: any,
  accessibility:any[],
  filters: FilterResult,
  hideAvailability(date: any):void,
  selectedFilters : SelectedFilters,
  toggleFilterGroup(name: string, expand?: boolean): void;
  searchMonths: any[]
  onFilterSelect(name: string, item: any): void;
  clearFilters(): void;
  deleteHeldResorts(): Promise<any>;
  getHeldResorts(displayHeldResorts?: boolean): void;
  placeHold(holdRequestData: HoldRequestData): Promise<any>;
  createWaitlist(waitlistData: WaitlistData): Promise<any>;
  goToAYP(resId: number): void;
  toggleAlertModal(type?: string): void;
  contracts: ContractType[];
  onMonthSelect(date: any): void;
  selectedMonth: any;
  setEditingSegment(segment: EnhancedSegment):void;
  waitlistToggleChecked: boolean;
  onClearSearch():void;
  criteria : Criteria;
  form:FormData;
  editingSegment: EnhancedSegment | null;
  goToWaitlistAYP(waitlistId: number): void;
  sessionId: any;
  apiTimeout: string;
   isAlternateSearchAvailable:boolean;
}

class CheckAvailability extends React.Component<Props, CheckAvailabilityState> {

  constructor(props: Props) {
    super(props);
    this.hideAvailability = this.hideAvailability.bind(this);
    this.toggleMobileFilter = this.toggleMobileFilter.bind(this);
    this.state = {
      dateSelected: false,
      hideHeader: false,
      isMobileFilterOpen: false,
    };
  }

  hideAvailability(firstEnabledDate:any){
    this.props.hideAvailability(firstEnabledDate);
  }

  toggleMobileFilter() {
      let el:any = document.getElementById('html')
      let box:any = document.getElementById('filter-box');

      box.classList.toggle("display")
      el.classList.toggle("overflow")
      this.setState({
      isMobileFilterOpen: !this.state.isMobileFilterOpen,
    })
    console.log(this.state.isMobileFilterOpen);
  }

  render() {
    return (
      <div className="check-availability">
        <div className="mobile-filter-toggle">
          <MvFilterBtn onClick={this.toggleMobileFilter} />
        </div>
        {!this.state.dateSelected ?
          <CheckAvailabilityResultItem
            isMobileFilterOpen={this.state.isMobileFilterOpen}
            toggleMobileFilter={this.toggleMobileFilter}
            clearFilters={this.props.clearFilters}
            isAlternateSearchAvailable={this.props.isAlternateSearchAvailable}
            searchMonths={this.props.searchMonths}
            result={this.props.result.result}
            form={this.props.result.form}
            hideAvailability={this.props.hideAvailability}
            toggleFilterGroup={this.props.toggleFilterGroup}
            selectedFilters={this.props.selectedFilters}
            onFilterSelect={this.props.onFilterSelect}
            deleteHeldResorts={this.props.deleteHeldResorts}
            getHeldResorts={this.props.getHeldResorts}
            placeHold={this.props.placeHold}
            createWaitlist={this.props.createWaitlist}
            goToAYP={this.props.goToAYP}
            toggleAlertModal={this.props.toggleAlertModal}
            accessibilityOptions={this.props.accessibility}
            waitlistToggleChecked={this.props.waitlistToggleChecked}
            onClearSearch ={this.props.onClearSearch}
            contracts={this.props.contracts}
            onMonthSelect={this.props.onMonthSelect}
            selectedMonth={this.props.selectedMonth}
            searchForm={this.props.form}
            criteria={this.props.criteria}
            goToWaitlistAYP={this.props.goToWaitlistAYP}
            setEditingSegment={this.props.setEditingSegment}
            editingSegment={this.props.editingSegment}
            sessionId={this.props.sessionId}
            apiTimeout={this.props.apiTimeout}
          /> : null
        }
      </div>
    );
  }
}

export default CheckAvailability;
